export default "<p>update-refrigerator-serial-number-dialog works!</p>\n"